var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMastercard = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 23,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#mastercard_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.014 20.166c.087.078.18.148.27.223a11.124 11.124 0 1 1 0-18.541c-.09.074-.183.145-.27.222a11.973 11.973 0 0 0 0 18.084v.012ZM24.875 0a11.078 11.078 0 0 0-6.158 1.854c.09.074.182.145.269.223a11.976 11.976 0 0 1 0 18.083c-.087.077-.18.148-.27.223A11.125 11.125 0 1 0 24.877 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 2.383c-.142.114-.284.228-.42.349a11.125 11.125 0 0 0 0 16.785c.136.12.278.235.42.35.142-.115.284-.23.42-.35a11.125 11.125 0 0 0 0-16.785c-.136-.12-.278-.235-.42-.35Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "mastercard_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v22.249H0z"
})))));
SvgMastercard.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgMastercard);
export default ForwardRef;